import { Reducer } from "redux";

import { AuthNotificationsListResponse } from "../models/api/Referral";
import { PostAuthNotificationsActionDispatchTypes } from "../constants/HomePage";
import { AuthNotificationsDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: AuthNotificationsListResponse = {
  loading: false,
  response: [],
  error: null,
};

const AuthNotificationsListReducer: Reducer<
  AuthNotificationsListResponse,
  AuthNotificationsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_RESET: {
      return initialState;
    }
  }
  return state;
};
export default AuthNotificationsListReducer;
